import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MarketCreators } from "redux/modules/market";
import InfiniteScroll from "./InfiniteScroll";
import { MOCK_USER_ID } from "../home/MarketHome";

import { MarketSearchContainer } from "./MarketSearchStyle";
import { Line } from "./MarketSearchStyle";

function MarketSearch() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const textRef = useRef(null);
  const [keyWord, setKeyWord] = useState("");
  const [autoCompleteWord, setAutoCompleteWord] = useState([]);
  const [wordList, setWordList] = useState([]); // 자동완성 목록
  const [show, setShow] = useState(false); // 자동완성 검색어 토글
  const [showSearchedItem, setShowSearchedItem] = useState(false); // 검색결과 리스트 토글
  const [searchedMarkets, setSearchedMarkets] = useState([]); // 검색결과 목록
  const [totalLength, setTotalLength] = useState(0); // 검색결과 총 개수
  const [page, setPage] = useState(0); // 현재 페이지

  // let debounceTimer;
  // const debounce = (callback, time, e) => {
  //   if (debounceTimer) {
  //     clearTimeout(debounceTimer);
  //   }
  //   debounceTimer = setTimeout(() => {
  //     callback(e);
  //   }, time);
  // };

  useEffect(() => {
    dispatch(MarketCreators.marketSearchAutoComplete())
      .unwrap()
      .then((res) => {
        setAutoCompleteWord(res.data);
      });
  }, [dispatch]);

  const pageFunc = () => {
    setPage((prev) => prev + 1);
  };

  const setSearchedMarketsFunc = (data) => {
    setSearchedMarkets((prev) => [...prev, ...data]);
  };

  // 입력
  const onChangeKeyWord = useCallback(
    (e) => {
      setKeyWord(e.target.value);
      setSearchedMarkets([]);
      setShow(true);
      setShowSearchedItem(false);

      const filterArr = autoCompleteWord.filter((v, i) =>
        v.search_nm.includes(`${e.target.value}`),
      );
      setWordList(filterArr);
    },
    [autoCompleteWord],
  );

  // 자동완성 검색어 클릭
  const onClickAuto = useCallback(
    (e) => {
      setKeyWord(e.target.innerHTML);
      setShow(false);
      setShowSearchedItem(true);

      const payload = {
        user_id: MOCK_USER_ID,
        searchNm: e.target.innerHTML.trim().replace(/ +(?= )/g, ""),
        page: page,
      };

      dispatch(MarketCreators.marketSearch(payload))
        .unwrap()
        .then((res) => {
          res.success && setSearchedMarkets(res.data);
          setTotalLength(res.tot_cnt);
        });
    },
    [dispatch, page],
  );

  // Enter로 검색
  const searchFunc = useCallback(
    (e) => {
      setShow(false);
      setShowSearchedItem(true);

      const payload = {
        user_id: MOCK_USER_ID,
        searchNm: keyWord.trim().replace(/ +(?= )/g, ""),
        page: page,
      };

      if (e.key === "Enter") {
        dispatch(MarketCreators.marketSearch(payload))
          .unwrap()
          .then((res) => {
            res.success && setSearchedMarkets(res.data);
            setTotalLength(res.tot_cnt);
          });
      }
      return null;
    },
    [dispatch, keyWord, page],
  );

  // 돋보기 클릭검색
  const onClickSearch = useCallback(() => {
    setShow(false);
    setShowSearchedItem(true);

    const payload = {
      user_id: MOCK_USER_ID,
      searchNm: keyWord.trim().replace(/ +(?= )/g, ""),
      page: page,
    };

    dispatch(MarketCreators.marketSearch(payload))
      .unwrap()
      .then((res) => {
        res.success && setSearchedMarkets(res.data);
        setTotalLength(res.tot_cnt);
      });
  }, [dispatch, keyWord, page]);

  // 리셋
  const onClickReset = useCallback((e) => {
    setKeyWord("");
    setShowSearchedItem(false);
    setSearchedMarkets([]);
    setTotalLength(0);
    setPage(0);
    textRef.current.focus();
  }, []);

  return (
    <MarketSearchContainer>
      <header>
        <img
          className="arrowBack"
          src="/img/arrowBack.svg"
          alt="arrow back"
          onClick={() => navigate(-1)}
        />
        <div className="inputSearch">
          <div>
            <img
              className="img__right"
              src="/img/searchBlack.svg"
              alt="Search icon"
              onClick={onClickSearch}
            />
          </div>
          <input
            ref={textRef}
            value={keyWord}
            onChange={onChangeKeyWord}
            type="text"
            autoFocus
            placeholder="도매상 이름 또는 꽃 품목을 검색하세요"
            onKeyDown={searchFunc}
          />
          {keyWord.length > 0 && (
            <img
              src="/img/resetBtn.svg"
              alt="검색창 초기화"
              onClick={onClickReset}
            />
          )}
        </div>
      </header>

      <Line />

      <main>
        {/* 자동검색어 렌더링 */}
        {show && (
          <>
            {wordList.length > 0 && (
              <div className="autoCompleteWordList">
                {wordList.map((v) => (
                  <div key={v.search_nm} className="autoCompleteWordItem">
                    <img src="/img/search_color.svg" alt="search" />
                    <span onClick={onClickAuto}>{v.search_nm}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
        {/* 검색완료 렌더링 */}
        {showSearchedItem && (
          <>
            {searchedMarkets.length > 0 ? (
              <InfiniteScroll
                page={page}
                totalLength={totalLength}
                searchedMarkets={searchedMarkets}
                keyWord={keyWord}
                pageFunc={pageFunc}
                setSearchedMarketsFunc={setSearchedMarketsFunc}
              />
            ) : (
              <>
                <div className="noneSearched">
                  검색결과가 없습니다. <br />
                  검색어를 다시 한번 확인해 보세요
                </div>
              </>
            )}
          </>
        )}
      </main>
    </MarketSearchContainer>
  );
}

export default MarketSearch;
